import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Send, Loader2, Eye } from "lucide-react";

export function EmailPreviewDialog({ open, onOpenChange, preview, loading, sending, onSend }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="email-preview-dialog" className="max-w-3xl bg-[#0d0d12] border-slate-800 text-slate-100 p-0 overflow-hidden">
        <DialogHeader className="px-6 pt-6 pb-4 border-b border-slate-800">
          <DialogTitle className="font-heading flex items-center gap-2 text-slate-100"><Eye className="w-4 h-4 text-cyan-400" /> Aperçu de l'email</DialogTitle>
          <DialogDescription className="text-slate-400 text-xs">Rendu exact tel qu'il sera reçu par le prospect (logo, mise en page, signature). Les réponses du prospect arrivent dans la boîte « Réponses ».</DialogDescription>
        </DialogHeader>

        {loading || !preview ? (
          <div className="h-[420px] flex items-center justify-center text-slate-500 font-mono text-sm"><Loader2 className="w-4 h-4 animate-spin mr-2" /> Génération de l'aperçu…</div>
        ) : (
          <>
            <div className="px-6 py-3 bg-slate-900/60 border-b border-slate-800 grid grid-cols-[70px_1fr] gap-y-1 text-xs">
              <span className="font-mono uppercase tracking-widest text-slate-500">De</span>
              <span data-testid="preview-from" className="text-slate-200">{preview.from_name}{preview.channel && preview.channel !== "platform" ? ` <${preview.channel}>` : " (plateforme)"}</span>
              <span className="font-mono uppercase tracking-widest text-slate-500">Réponses</span>
              <span data-testid="preview-reply-to" className="text-cyan-300">{preview.reply_to || "—"}</span>
              <span className="font-mono uppercase tracking-widest text-slate-500">À</span>
              <span data-testid="preview-to" className="text-slate-200">{preview.to}</span>
              <span className="font-mono uppercase tracking-widest text-slate-500">Objet</span>
              <span data-testid="preview-subject" className="text-slate-100 font-medium">{preview.subject}</span>
            </div>
            <iframe
              data-testid="preview-iframe"
              title="Aperçu email"
              srcDoc={preview.html}
              sandbox=""
              className="w-full h-[460px] bg-[#f6f7fb] border-0"
            />
          </>
        )}

        <div className="px-6 py-4 border-t border-slate-800 flex items-center justify-between gap-3">
          <span className="text-[11px] text-slate-500">
            {preview?.tracking ? "Suivi d'ouverture activé" : "Suivi d'ouverture indisponible (URL publique manquante)"}
          </span>
          <div className="flex gap-2">
            <button data-testid="preview-close-button" onClick={() => onOpenChange(false)} className="px-4 py-2 rounded-lg text-sm text-slate-300 hover:bg-slate-800 border border-slate-800 transition-colors">Modifier</button>
            <button
              data-testid="preview-send-button"
              onClick={onSend}
              disabled={sending || loading || !preview}
              className="px-4 py-2 rounded-lg bg-cyan-500 hover:bg-cyan-400 text-slate-950 font-semibold text-sm transition-colors flex items-center gap-2 disabled:opacity-60"
            >
              {sending ? <><Loader2 className="w-4 h-4 animate-spin" /> Envoi…</> : <><Send className="w-4 h-4" /> Confirmer l'envoi</>}
            </button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
